import { render } from "./Booking.vue?vue&type=template&id=6f5b5cce"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"
script.render = render

export default script